module.exports = __webpack_public_path__ + "static/media/akademia.d6a951a0.jpg";